import React from 'react';
import Home from "pages/home/page";
import ElevePage from "pages/home/pages/eleve/ElevePage";
import ExerciceListePage from "pages/home/pages/exercice/ExerciceListePage";
import ExerciceLecturePage from "pages/home/pages/exercice/ExerciceLecturePage";
import MatierePage from "pages/home/pages/matiere/MatierePage";
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouterProvider,
} from "react-router-dom";
import ExerciceMathPage from "pages/home/pages/exercice/ExerciceMathPage";
import HistoriquePage from "pages/home/pages/historique/HistoriquePage";
import DetailHistoriquePage from "pages/home/pages/historique/pages/DetailHistoriquePage";
import DiagnostiqueHistoriquePage from "pages/home/pages/matiere/pages/DiagnostiqueHistoriquePage";
import AnalysePage from "pages/home/pages/analyse/AnalysePage";
import ComparaisonPage from "pages/home/pages/comparaison/ComparaisonPage";
import ExerciceDetailPage from "pages/home/pages/exerciceDetail/ExerciceDetailPage";
import ContactGenimiPage from "pages/home/pages/contactGenimi/ContactGenimiPage";
import ContactGenimiSuccessPage from "pages/home/pages/contactGenimi/ContactGenimiSuccessPage";
import ParentProspectPage from "pages/home/pages/AuthParent/ParentProspectPage";
import ProfilePage from "pages/home/pages/ProfilePage/ProfilePage";
import NombreEnfantPage from "pages/home/pages/eleve/forms/NombreEnfantPage";
import FormEnfant from "pages/home/pages/eleve/forms/FormEnfant";
import EditEnfantPage from "pages/home/pages/eleve/forms/EditEnfant";
import InfoBeforeDiagnosticPage from "pages/home/pages/eleve/forms/InfoBeforeDiagnosticPage";
import SelectEnfantPage from "pages/home/pages/eleve/forms/SelectEnfantPage";
import OnBoarding from "pages/onboarding/page";
import NewOnboardingPage from "pages/new-onboarding/NewOnboardingPage";
import PayementPage from "pages/home/pages/payement/PayementPage";
import PayementSuccessPage from "pages/home/pages/payement/PayementSuccessPage";
import PayementErrorPage from "pages/home/pages/payement/PayementErrorPage";
import CameraPage from "pages/home/pages/Camera";
import ChatPage from "pages/home/pages/Chat";
import AudioPage from "pages/home/pages/Audio";
import DignostiquePageNew from "pages/home/pages/diagnostic";
import Root from "../Root";
import useGetUserInfo from "hooks/useGetUserInfo";
import HomeworkHelpPage from "pages/home/pages/matiere/pages/HomeworkHelpPage";
import HomeworkQuizPage from "pages/home/pages/matiere/pages/HomeworkQuizPage";
import HomeworkResolutionPage from "pages/home/pages/matiere/pages/HomeworkResolutionPage";
import ErrorFallback from 'components/ErrorFallback';
import NotFoundPage from 'pages/NotFoundPage';
import TestErrorPage from 'pages/TestErrorPage';
/**
 * Public routes
 */
export const publicRoutes = [
  // Ancien onboarding désactivé - remplacé par /new-onboarding
  // {
  //   path: "/welcom",
  //   element: <OnBoarding />,
  // },
  {
    path: "/new-onboarding",
    element: <NewOnboardingPage />,
  },
  {
    element: <ParentProspectPage />,
    path: "parentProspect",
  },
  {
    path: "/test-error",
    element: <TestErrorPage />,
  },
  // // {
  // //   path: "/*",
  // //   element: <Navigate to={"/login"} />,
  // // },
  // {
  //   path: "/login",
  //   element: <Login />,
  // },
  // {
  //   path: "/register/:phone",
  //   element: <Register />,
  // },
];

/**
 * Private routes
 */
export const privateRoutes = [
  // Route onboarding accessible aussi pour les utilisateurs connectés
  {
    path: "/new-onboarding",
    element: <NewOnboardingPage />,
  },
  // {
  //   path: "*",
  //   element: <Navigate to={"/"} />,
  // },
  // {
  //   element: <ParentProspectPage />,
  //   path: "parentProspect",
  // },
  // {
  //   element: <Home />,
  //   path: "",
  // },
  {
    element: <ElevePage />,
    path: "eleves",
  },
  {
    element: <Outlet />,
    path: "parentProspect",
    children: [
      { element: <ParentProspectPage />, path: "" },
      {
        element: <NombreEnfantPage />,
        path: "enfant",
      },
      {
        element: <FormEnfant />,
        path: "form",
      },
      {
        element: <InfoBeforeDiagnosticPage />,
        path: "info",
      },
      {
        element: <SelectEnfantPage />,
        path: "select-enfant",
      },
      {
        element: <EditEnfantPage />,
        path: "edit-enfant/:eleveId",
      },
    ],
  },
  {
    element: <Outlet />,
    path: ":eleveId",
    children: [
      {
        element: <MatierePage />,
        path: "matiere",
        children: [
          {
            element: <DiagnostiqueHistoriquePage />,
            path: "",
          },
          {
            element: <Outlet />,
            path: ":name",
            children: [
              {
                element: <ExerciceListePage />,
                path: "",
              },
              // {
              //   element: <ExerciceMathPage />,
              //   path: "math/:id",
              // },
              // {
              //   element: <ExerciceLecturePage />,
              //   path: "lecture/:id",
              // },
            ],
          },
          {
            element: <Outlet />,
            path: "historiques",
            children: [
              { element: <HistoriquePage />, path: ":id" },
              {
                element: <DetailHistoriquePage />,
                path: "detail/:tentativeId",
              },
            ],
          },
        ],
      },
      {
        element: <Outlet />,
        path: "homework",
        children: [
          {
            element: <HomeworkHelpPage />,
            path: "",
          },
          {
            element: <HomeworkQuizPage />,
            path: "quiz",
          },
          {
            element: <HomeworkResolutionPage />,
            path: "resolution",
          },
        ],
      },
      {
        element: <Outlet />,
        path: ":name",
        children: [
          {
            element: <ExerciceMathPage />,
            path: "math/:id",
          },
          {
            element: <ExerciceLecturePage />,
            path: "lecture/:id",
          },
          {
            element: <AnalysePage />,
            path: "analyse/:id",
          },
          {
            element: <ComparaisonPage />,
            path: "comparaison/:id",
          },
          {
            element: <ExerciceDetailPage />,
            path: "exercice-detail",
          },
          {
            element: <Outlet />,
            path: "contact-genimi",
            children: [
              {
                element: <ContactGenimiPage />,
                path: "",
              },
            ],
          },
          {
            element: <ContactGenimiSuccessPage />,
            path: "contact-genimi/success",
          },
        ],
      },
    ],
  },
  {
    element: <Outlet />,
    path: "contact-genimi",
    children: [
      {
        element: <ContactGenimiPage />,
        path: "",
      },
      {
        element: <ContactGenimiSuccessPage />,
        path: "success",
      },
    ],
  },
  {
    path: "payment",
    element: <Outlet />,
    children: [
      {
        path: "",
        element: <PayementPage />,
      },
      {
        path: "success",
        element: <PayementSuccessPage />,
      },
      {
        path: "error",
        element: <PayementErrorPage />,
      },
    ],
  },
  {
    path: "camera",
    element: <CameraPage />,
  },
  {
    path: "chat",
    element: <ChatPage />,
  },
  {
    path: "audio",
    element: <AudioPage />,
  },
  {
    path: "new",
    element: <DignostiquePageNew />,
  },
  {
    path: "profile",
    element: <ProfilePage />,
  },
  {
    path: "/test-error",
    element: <TestErrorPage />,
  },
];

const Routes = ({ isPWASupported }) => {
  const { userId, onBoarding } = useGetUserInfo();

  const roots = createBrowserRouter([
    {
      element: <Root isPWASupported={isPWASupported} />,
      path: "",
      errorElement: <ErrorFallback />,
      children: [
        // {
        //   path: "",
        //   element: <RequireParent />,
        //   children: [...privateRoutes],
        // },
        // Redirection vers le nouveau onboarding au lieu de l'ancien
        {
          element: !onBoarding ? <Navigate to={"/parentProspect"} /> : <Home />,
          path: "",
        },
        // {
        //   element: <Navigate to={"/"} />,
        //   path: "*",
        // },
        // {
        //   element: <ParentProspectPage />,
        //   path: "parentProspect",
        // },
        ...(userId ? privateRoutes : publicRoutes),
        // Route catch-all pour les 404 - DOIT être en dernier
        {
          path: "*",
          element: <NotFoundPage />,
        },
      ],
    },
  ]);

  return <RouterProvider router={roots} />;
};

export default Routes;
